// Slovenské dvojče locale/cs/searchRender.js.
export default {
  h1Pre: 'Hľadali ste ',
  quoteOpen: '„',
  quoteClose: '“',
  chipsLabel: 'Kategórie',
  chipsMore: (n) => 'Ďalšie (' + n + ')',
  chipsLess: 'Menej',
  catFound: ['nájdený', 'nájdené', 'nájdených'],
  showAll: (n) => 'Zobraziť všetko (' + n + ')',
  shown: 'Zobrazené ',
  nonePre: 'Pre ',
  nonePost: ' sme nič nenašli',
  noneText:
    'Skontrolujte preklepy alebo skúste všeobecnejší výraz: namiesto označenia modelu hľadajte typ náradia. Radi vám poradíme aj telefonicky.',
  noneTextNoPhone:
    'Skontrolujte preklepy alebo skúste všeobecnejší výraz: namiesto označenia modelu hľadajte typ náradia. Radi vám poradíme aj e-mailom.',
  nonePlaceholder: 'Skúste hľadať inak…',
  submit: 'Hľadať',
  queries: 'Najhľadanejšie dopyty',
  browse: 'Prechádzať kategórie',
  didYouMean: 'Mysleli ste: ',
  tips: [
    'Skúste kratší alebo všeobecnejší výraz: namiesto „OD9081w 100 mm“ hľadajte „priamočiara píla“.',
    'Skontrolujte diakritiku a preklepy, vyhľadávanie je na ne citlivé.',
    'Hľadajte podľa značky: ONDRAGON, BULLTECH, POWERMAT, GEKO, BASS.',
    'Alebo produkt nájdite v katalógu podľa kategórie nižšie.',
  ],
  typoTipIndex: 1,
  advice: {
    eyebrow: 'Poradňa Jipos',
    title: 'Neviete, ako sa to volá?',
    text: 'Opíšte nám, čo potrebujete. Nájdeme model a poradíme s výkonom aj príslušenstvom.',
    textNoPhone: 'Napíšte nám, čo potrebujete. Nájdeme model a poradíme s výkonom aj príslušenstvom.',
    mailLabel: 'Napísať dotaz',
  },
  plurals: {
    cats: ['kategória', 'kategórie', 'kategórií'],
    brands: ['značka', 'značky', 'značiek'],
    posts: ['článok', 'články', 'článkov'],
    pages: ['stránka', 'stránky', 'stránok'],
    products: ['produkt', 'produkty', 'produktov'],
  },
};
